import React, { useState, useEffect } from "react";
import MainTable from "../../../components/Table/PaginationTable";
import { ProcessLossColumnDef } from "../../Orders/columns/columnDef";
import { useDispatch, useSelector } from "react-redux";
import { fetchActualProcessLoss } from "../../../redux/processLossSlice";
import dayjs from "dayjs";
import FilterPanel from "../../../components/common components/FilterPanel";
import DownloadButton from "../../../components/common components/DownloadButton";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@mui/material";
import FileOutlineIcon from '@mui/icons-material/Description';
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
// import TextField from "@mui/material/TextField";
// import InputAdornment from "@mui/material/InputAdornment";
// import SearchIcon from "@mui/icons-material/Search";
// import searchIcon from "../../../assets/images/search.svg";

const ActualLoss = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  /********************************* State Management *********************************/

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecordsCountValue, settotalRecordsCountValue] = useState("");
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [filterCriteria, setFilterCriteria] = useState({search: "",fromDate: "",toDate: ""});
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [processLossType, setProcessLossType] = useState("actual");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  // const [searchValue, setSearchValue] = useState("");

  /********************************* Use Effect *********************************/
  useEffect(() => {
    const formattedCriteria = {
      search: "",
      fromDate: "",
      toDate: "",
    };
    setFilterCriteria(formattedCriteria);
    const queryParams = {
      type: processLossType,
      searchText: "",
      fromDate: "",
      toDate: "",
      pageSize: downloadFlag === true ? totalRecordsCountValue : pageSize, // Use state value
      pageNumber, // Use state value
    };
    dispatch(fetchActualProcessLoss(queryParams));
  }, [dispatch, pageSize, pageNumber]);

  /********************************* Functions  Fetch State Varibles from Store *********************************/
  const totalRecords =
    useSelector(
      (state) => state.processLoss.processLossPageInfo?.totalRecords
    ) || 0;

  const tableData = useSelector(
    (state) => state.processLoss.actualProcessLossList
  );

  /********************************* Functions *********************************/

  //Function to set new Index page
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  //Function to set new page size
  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };

  //Function to downlaod Flag to true
  const handleDownloadFlag = () => {
    settotalRecordsCountValue(totalRecords);
    setDownloadFlag(true);
  };

  //Function to handle Export click
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //Function to handle Export close
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to handle date filter action
  const handleFilter = (criteria) => {
    const formattedCriteria = {
      searchText: criteria.search !== undefined ? criteria.search : "",
      fromDate: criteria.fromDate
        ? dayjs(criteria.fromDate).format("YYYY-MM-DD")
        : "",
      toDate: criteria.toDate
        ? dayjs(criteria.toDate).format("YYYY-MM-DD")
        : "",
    };

    // Set the Filer Values in the state variable.
    setFilterCriteria(formattedCriteria);

    // Perform filtering logic based on criteria
    const queryParams = {
      type: processLossType,
      searchText: formattedCriteria.searchText,
      fromDate: formattedCriteria.fromDate,
      toDate: formattedCriteria.toDate,
      pageSize,
      pageNumber,
    };
    dispatch(fetchActualProcessLoss(queryParams));
  };

  // Function to handle reset action
  const handleReset = async () => {
    const formattedCriteria = {
      type: processLossType,
      searchText: "",
      fromDate: "",
      toDate: "",
      pageSize,
      pageNumber,
    };
    // Set the Filer Values in the state variable.
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    dispatch(fetchActualProcessLoss(formattedCriteria));
  };

  // // Function to handle dynamic serach filter action
  // const handleSearchChange = (e) => {
  //   setSearchValue(e.target.value);
  //   const formattedCriteria = {
  //     search: e.target.value,
  //   };
  //   // Set the Filer Values in the state variable.
  //   setFilterCriteria(formattedCriteria);
  //   // Perform filtering logic based on criteria
  //   callFetchActualProcessLoss(formattedCriteria);
  // };


  //Function to call API
  // const callFetchActualProcessLoss = (formattedCriteria) => {
  //   const queryParams = {
  //     type: processLossType,
  //     searchText:
  //       filterCriteria.search !== undefined ? filterCriteria.search : (formattedCriteria.search !== undefined ? formattedCriteria.search : ""),
  //     fromDate:
  //       filterCriteria.fromDate !== undefined ? filterCriteria.fromDate : (formattedCriteria.fromDate !== undefined ? formattedCriteria.fromDate : ""),
  //     toDate: filterCriteria.toDate !== undefined ? filterCriteria.toDate : (formattedCriteria.toDate !== undefined ? formattedCriteria.toDate : ""),
  //     pageSize,
  //     pageNumber,
  //   };
  //   dispatch(fetchActualProcessLoss(queryParams));
  // };

  /********************************* UI Components *********************************/

  const columnDef = ProcessLossColumnDef(); //Table-Date_template
  return (
    <div>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div style={{ marginLeft: "10px" }}>
            <h1 className="heading1">Actual Process Loss</h1>
            <h5 className="heading2">
              Actual process loss of shipped products.
            </h5>
          </div>
          <div>
            <h5 className="navPageIfo">
              Home / <span style={{ color: " #C8C7C9" }}>Process Loss</span>
            </h5>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            {/* <TextField
              placeholder="Search by keyword..."
              variant="outlined"
              value={searchValue}
              onChange={handleSearchChange}
              fullWidth
              className="btn-light grey-btn md_btn me-0"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div className="icon-clay">
                      <span class="inner-clay color-black">
                        <img src={searchIcon} alt="Search" />
                      </span>
                    </div>
                  </InputAdornment>
                ),
              }}
            /> */}
          </div>
          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{ backgroundColor: "#6AA13C" }}
              className="btn btn-primary greeen-btn md_btn m-2 h-100"
              startIcon={<FileOutlineIcon />}
            >
              {t("btnGrpText.downloadOrders")}
            </Button>

            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                {" "}
                <DownloadButton
                  data={tableData}
                  filename="ProcessLoss.xlsx"
                  sheetname="Process Loss"
                  forModule="Process Loss"
                  onDownload={handleDownloadFlag}
                />
              </MenuItem>
            </Menu>
            <button
              className="btn btn-light grey-btn md_btn me-0"
              onClick={() => setIsFilterPanelOpen((prevState) => !prevState)}
            >
              <span>
                <i className="bi bi-funnel">
                  <FilterAltOutlinedIcon />
                </i>
              </span>{" "}
              {t("orderOutboxcomponents.filters")}
            </button>
          </div>
        </div>
      </div>
      {isFilterPanelOpen && (
        <FilterPanel
          className="mb-3"
          onFilter={handleFilter}
          onReset={handleReset}
          isFromDateToDate={true}
        />
      )}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords}
        recordCountText="records found"
      />
    </div>
  );
};

export default ActualLoss;
